import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: 20px;
  background: ${({ theme }) => theme.palette.white};
  border: 1px solid ${({ theme }) => theme.palette.grey300};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
`;

export const DateContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 40px;
  width: 100%;
`;

export const DateContainerMobile = styled.div`
  display: grid;
  width: 100%;
`;

export const Separate = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.palette.grey300};
  margin: 16px 0;
`;

export const DateSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DateHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const DateLabel = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 18px;
  font-weight: 700;
  line-height: 23px;
`;

export const DateValue = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
`;

export const Description = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;

  p {
    margin: 0;
  }

  br {
    display: block;
    content: '';
    margin-top: 0.5em;
  }

  ul,
  ol {
    margin: 0.5em 0;
    padding-left: 1.5em;
  }

  li {
    margin: 0.25em 0;
  }
`;

export const Separator = styled.div`
  width: 1px;
  align-self: stretch;
  background: ${({ theme }) => theme.palette.grey300};
  min-height: 107px;

  @media (max-width: 768px) {
    display: none;
  }
`;
